import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apiAction, generalSet } from '../../store/generalSlice';
import { Link } from 'react-router-dom';

const CreateChangeStatus = () => {
  // Possible status values:
  // ACTIVE = 'ACTIVE',
  // PAUSED = 'PAUSED',
  // ARCHIVED = 'ARCHIVED',

  const dispatch = useDispatch();
  const actionType = 'CHANGE_STATUS';
  const { actionCreatedChangeStatus, actionCreatedChangeStatusLoading } = useSelector((state) => state.general);
  const [actionData, setActionData] = useState({ status: 'ACTIVE' });

  if (actionCreatedChangeStatus?._id) {
    dispatch(generalSet({ reduxField: 'actionCreatedChangeStatus', value: {} }));
    window.location.href = '/actions';
  }
  console.log({ actionCreatedChangeStatus });
  return (
    <>
      <div>
        <Link to='/CreateAction' className='btn btn-outline-dark'>
          Change Action Type
        </Link>
      </div>
      <div className='container mt-4' data-aos='fade-up' data-aos-delay='200'>
        <div className='row d-flex justify-content-center border-bottom'>
          <h1>
            Create Action: <span className='text-primary'>Change Status</span>
          </h1>
        </div>
        <div className='row d-flex justify-content-center mt-4'>
          <div className='col-md-6'>
            <input
              type='text'
              className='form-control'
              placeholder='Action name...'
              style={{ textAlign: 'center' }}
              onChange={(e) => setActionData({ ...actionData, name: e.target.value })}
            />
          </div>
        </div>
        <div className='row d-flex justify-content-center mt-4'>
          <div className='col-md-6'>
            <select
              type='text'
              className='form-control select'
              placeholder='Action name...'
              style={{ textAlign: 'center' }}
              onChange={(e) => setActionData({ ...actionData, status: e.target.value })}
            >
              <option value='ACTIVE'>ACTIVE</option>
              <option value='PAUSED'>PAUSED</option>
              <option value='ARCHIVED'>ARCHIVED</option>
            </select>
          </div>
        </div>
        {actionData.name && actionData.status ? (
          <>
            <div className='row d-flex justify-content-center mt-4' data-aos='fade-up' data-aos-delay='200'>
              <button
                className='btn btn-outline-primary'
                disabled={actionCreatedChangeStatusLoading}
                onClick={() => {
                  dispatch(generalSet({ reduxField: 'actionCreatedChangeStatusLoading', value: true }));
                  dispatch(
                    apiAction({
                      route: 'actions/createAction',
                      reduxField: 'actionCreatedChangeStatus',
                      actionType,
                      actionData,
                      setLoading: 'actionCreatedChangeStatusLoading',
                    })
                  );
                }}
              >
                Create Action
              </button>
            </div>
          </>
        ) : null}
      </div>
    </>
  );
};

export default CreateChangeStatus;
